import { dehydrate, QueryClient } from "@tanstack/react-query";
import { GetStaticProps, NextPage } from "next";

import DefaultLayout from "@/components/layouts/DefaultLayout";
import Exercises from "@/components/views/Exercises/Exercises";
import { SEO_DEFAULT } from "@/constants/SeoDefault";
import { getExercises } from "@/services/DefaultService";

const Index: NextPage = () => {
  return (
    <DefaultLayout seo={SEO_DEFAULT}>
      <Exercises />
    </DefaultLayout>
  );
};

export const getStaticProps: GetStaticProps = async (context) => {
  const queryClient = new QueryClient();
  const pagination = {
    page: 1,
    pageSize: 10,
  };
  const sort = ["createdAt:desc"];
  await queryClient.prefetchQuery(["getExercises", pagination, sort], () =>
    getExercises({
      key: "getExercises",
      pagination,
      sort,
    })
  );
  return {
    props: {
      dehydratedState: dehydrate(queryClient),
    },
  };
};

export default Index;
